import "@/plugins/v-calendar";
import { createProviderSchedulesState } from "@/controllers/schedulesState";
import schedulesLifecycle from "@/controllers/schedulesLifecycle";
import schedulesDataMethods from "@/controllers/schedulesDataMethods";
import schedulesViewMethods from "@/controllers/schedulesViewMethods";
import schedulesStatusMethods from "@/controllers/schedulesStatusMethods";
import schedulesMemoMethods from "@/controllers/schedulesMemoMethods";
import schedulesRescheduleMethods from "@/controllers/schedulesRescheduleMethods";
import schedulesRingPickupMethods from "@/controllers/schedulesRingPickupMethods";
import schedulesOfflineMethods from "@/controllers/schedulesOfflineMethods";
import RescheduleRequestDialog from "@/components/RescheduleRequestDialog.vue";
import RingPickupDateDialog from "@/components/RingPickupDateDialog.vue";
import ReservationConsultationInfo from "@/components/ReservationConsultationInfo.vue";

export default {
  components: {
    RescheduleRequestDialog,
    RingPickupDateDialog,
    ReservationConsultationInfo,
  },
  data() {
    return createProviderSchedulesState();
  },
  ...schedulesLifecycle,
  methods: {
    ...schedulesDataMethods,
    ...schedulesViewMethods,
    ...schedulesStatusMethods,
    ...schedulesMemoMethods,
    ...schedulesRescheduleMethods,
    ...schedulesRingPickupMethods,
    ...schedulesOfflineMethods,
  },
};
